<template>
  <v-dialog
    v-model="show"
    width="450"
    persistent
  >
    <v-card>
      <v-card-title class="headline blue lighter-4 white--text" primary-title>
        <span>
          Criar pasta
        </span>
      </v-card-title>

      <v-form ref="customFolderForm">
        <v-layout>
          <v-flex>
            <v-layout>
              <v-card-text>
                <div
                  class="ml-3 mb-2 subheading font-weight-bold"
                >
                  <span>Nome da pasta:</span>
                  <v-text-field
                    v-model="customFolder.name"
                    label="Nome da pasta"
                    :rules="[validationRules.required]"
                    counter="30"
                    maxlength="30"
                  />
                </div>
              </v-card-text>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-form>
      <v-card-actions>
        <v-layout justify-center>
          <v-btn flat
                 @click="saveCustomFolder"
                 :loading="isSaving"
          >
            Salvar
          </v-btn>
          <v-btn @click="close" flat>Cancelar</v-btn>
          <v-tooltip></v-tooltip>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import customFolderService from "../../../services/CustomFolderService";
import validationRules from "@/mixins/validation-rules";

export default {
  name: "CustomFolderDialog",
  props: {
    show: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      customFolder: {},
      customFolderForm: true,
      valid: false,
      validationRules,
      isSaving: false
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },

    resetForms() {
      this.$refs.customFolderForm.resetValidation();
    },

    validateForms() {
      this.$refs.customFolderForm.validate();
    },

    saveCustomFolder() {
      this.validateForms();

      if (this.$refs.customFolderForm.validate()) {
        const formData = new FormData();
        formData.append("name", this.customFolder.name);

        this.isSaving = true;

        // if (this.customFolder.id) {
        //   customFolderService
        // }

        customFolderService
          .createCustomFolder(formData)
          .then(({ data }) => {
            this.$store.dispatch("toggleSnackbar", {
              show: true,
              timeout: 6000,
              color: "success",
              message: "Pasta criada com sucesso!",
              messageIcon: "mdi-check"
            });
            this.$emit("created-folder");
            this.close();
          })
          .catch(err => {
            this.$store.dispatch("toggleSnackbar", {
              show: true,
              timeout: 6000,
              color: "error",
              message: err.response.data.error,
              messageIcon: "mdi-check"
            });
          })
          .finally(() => {
            this.isSaving = false;
          });
      }
    }
  },
  computed: {}
};
</script>



// WEBPACK FOOTER //
// src/components/folder/new-custom-folder/NewCustomFolderDialog.vue